import { isDefined } from '@sgme/fp';

import type { BidAskRate } from '@/utils/number-point.ts';

type Parameters = {
  pinnedFarPrice: BidAskRate | undefined;
  spot: BidAskRate;
  farDeltaRate: BidAskRate;
};

// FarPriceClientBid (Client Far price)
// =SpotPriceClientBid+FarPointsClientBid*10^-4
export function computeFarPrice({ pinnedFarPrice, spot, farDeltaRate }: Parameters): BidAskRate {
  if (isDefined(pinnedFarPrice)) {
    return pinnedFarPrice;
  }
  return {
    bid: spot.bid + farDeltaRate.bid,
    ask: spot.ask + farDeltaRate.ask,
  };
}
